import React from "react";
import { Container } from "react-bootstrap";
import insta from "../assets/svgs/instagram.svg";
import { details } from "../../src/data/coachesDetails";

export default function Coach() {
  function onClick(item) {
    if (item === "Andrea Osterman") {
      window.open("https://glovesup.as.me/?calendarID=11242502", "_blank");
    }
    if (item === "Mickael Alban") {
      window.open(
        "https://glovesup.as.me/schedule/99e1705c/appointment/35680597/calendar/7085881?appointmentTypeIds%5B%5D=35680597",
        "_blank"
      );
    }
    if (item === "Stefanie Folgado") {
      window.open("https://glovesup.as.me/?calendarID=11306062", "_blank");
    }
  }

  return (
    <Container>
      <div className="coach-grid">
        {details.map((item, index) => (
          <div className="card" key={index}>
            <img
              src={item.img}
              className="card-img-top coach-img"
              alt={`Toronto boxing coach ${item.name} self portrait`}
            />
            <div className="card-body coach-body">
              <div>
                <h5 className="card-title coach-title">{item.name}</h5>
                <p className="card-text coach-text">{item.desc}</p>
              </div>
              <div className="coach-contact">
                <div className="coach-insta">
                  <img
                    src={insta}
                    className="coach-insta-img"
                    alt={`Toronto boxing coach ${item.name} instagram`}
                  />
                  <a href={item.insta}>Instagram</a>
                </div>
                {["Mickael Alban", "Andrea Osterman", "Stefanie Folgado"].includes(item.name) && (
                  <a
                    className="btn btn-primary"
                    onClick={() => onClick(item.name)}
                  >
                    Book a Session
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
}
